import React, { useState, useRef } from 'react'
import styles from './auth.module.scss'
import Login from './login'
import Signup from './signup'
import { strings } from '../utils/translations'
import CloseIcon from '../../img/icons/closeIcon'
import {ReactComponent as BackIcon} from '../../img/icons/chevron_left.svg'
import classnames from 'classnames'

const AuthBlock = (props) =>
{
    const [register, setRegister] = useState(false)
    const [login, setLogin] = useState(true)
    const [loginExtraScreenVisible, setLoginExtraScreenVisible] = useState(false)
    
    const loginRef = useRef(null)
  
    const { onClickClose } = props

    const onClickOvertitle = () =>
    {
        if (loginExtraScreenVisible)
        {
            if (loginRef != null && loginRef.current != null)
            {
                loginRef.current.closeForgot()
                loginRef.current.closeVerifyNewDevice()
                loginRef.current.closeQrLogin()
            }
        }
        else
        {
            setRegister(!register)
            setLogin(!login)
        }
    }
    const onForgotPasswordShown = (visible) =>
    {
        setLoginExtraScreenVisible(visible)
    }
    const onVerifyDeviceShown = (visible) =>
    {
        setLoginExtraScreenVisible(visible)
    }
    const onQRLoginShown = (visible) =>
    {
        setLoginExtraScreenVisible(visible)
    }
  

    return (
        <div className={classnames(styles.authBlock, 'animate__animated animate__fadeInDown animate__delay-1s')}>
            {
                (login === true) &&
                <>
                    <div className={styles.authClose}>
                        <h5 onClick={() => onClickOvertitle()}>
                            {
                                loginExtraScreenVisible ?
                                <><div className={styles.backIcon}><BackIcon /></div> { strings('login') }</>
                                :
                                strings('register')
                            }
                        </h5>
                        <CloseIcon className={styles.closeIcon} size="16" onClick={onClickClose} />
                    </div>
                    <div className={styles.authContent}>
                        <Login
                            ref={loginRef}
                            onForgotPasswordShown={onForgotPasswordShown.bind(this)}
                            onVerifyDeviceShown={onVerifyDeviceShown.bind(this)}
                            onQRLoginShown={onVerifyDeviceShown.bind(this)}
                        />
                    </div>
                </>
            }
            {
                (register === true) &&
                <>
                    <div className={styles.authClose}>
                        <h5 onClick={() => onClickOvertitle()}>
                            <div className={styles.backIcon}><BackIcon /></div> { strings('login') }
                        </h5>
                        <CloseIcon className={styles.closeIcon} size="16" onClick={onClickClose} />
                    </div>
                    <div className={styles.authContent}>
                        <Signup />
                    </div>
                </>
            }
        </div>
    )
}

export default AuthBlock